<template>
  <div :id="INSPIRATION_MODAL_ID">
    <div class="bg-black/50 fixed top-0 left-0 w-full h-full z-[100]"></div>
    <div
      class="absolute top-0 left-1/2 -translate-x-1/2 translate-y-[calc(-100%-8px)] bg-dark w-[calc(100%-60px)] px-4 pb-6 pt-3 flex flex-col rounded-2xl point z-[9999]"
    >
      <FontIcon
        class="icon-close text-dark-100 !text-[16px] ml-auto cursor-pointer"
        data-test-id="btn_close"
        @click="close"
      />
      <div class="flex flex-col gap-2 items-center mb-6">
        <p class="text-button1 font-semibold text-white">
          {{ t('needInspiration') }}
        </p>
        <p class="text-caption text-white" v-html="t('smartMatchAi')"></p>
      </div>
      <div class="relative z-0">
        <SmartAiButton @click="showSmartMatchAiModal">{{ t('learnMore') }}</SmartAiButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SmartAiButton from '@/components/inputs/button/SmartAiButton.vue';
import FontIcon from '@/components/inputs/icon/font-icon/FontIcon.vue';
import SmartMatchAiModal from '@/components/smart-match-ai/smart-match-ai/components/smart-match-ai-modal/SmartMatchAiModal.vue';
import { INSPIRATION_MODAL_ID } from '@/pages/chat/components/chat-view/helpers/chat/chat';
import { bq } from '@/services/bq/bq';
import { useI18n } from '@/services/i18n';
import { useModal } from '@/services/modal/modal';

import * as i18n from './i18n';

const { t } = useI18n({ messages: i18n.messages });

const emit = defineEmits(['close']);

function close() {
  emit('close');
}

function showSmartMatchAiModal() {
  close();

  bq.track('user_action', {
    page_name: 'dialogue',
    action_name: 'Learn more',
    block: 'product',
  });

  useModal(() => ({
    component: SmartMatchAiModal,
    props: { source: 'dialogue' },
  })).showModal();
}
</script>

<style scoped lang="scss"></style>
